import CrudSection from "./CrudSection";

const SECTIONS = [
  { value: "spoken_english", label: "Spoken English" },
  { value: "test_skills", label: "Test Your English Skills" },
  { value: "grammar", label: "Grammar Concepts" },
  { value: "literature", label: "Literature Chapters" },
  { value: "news", label: "Percept News" },
];

const FIELDS = [
  { name: "title", label: "Title", type: "text", full: true },
  { name: "youtube_url", label: "YouTube URL", type: "text", full: true, placeholder: "https://www.youtube.com/watch?v=…" },
  { name: "section", label: "Section", type: "select", options: SECTIONS },
  { name: "level", label: "Level / Tag", type: "text", placeholder: "Beginner / Class 10 / Announcement" },
  { name: "order", label: "Order within section", type: "number" },
  { name: "active", label: "Active", type: "checkbox", placeholder: "Show on website" },
];

export default function AdminVideos() {
  return (
    <CrudSection
      title="Videos"
      endpoint="videos"
      testIdPrefix="video"
      fields={FIELDS}
      defaultValues={{ active: true, order: 0, section: "spoken_english" }}
      renderRow={(v) => (
        <div>
          <div className="flex items-center gap-2 mb-1">
            <h3 className="font-display font-bold text-base text-[#1F2547] truncate">{v.title}</h3>
            <span className="text-[10px] font-bold uppercase tracking-[0.15em] px-2 py-0.5 rounded-full bg-[#EFE9F7] text-[#1F2547]">
              {SECTIONS.find((s) => s.value === v.section)?.label || v.section}
            </span>
            {v.level && (
              <span className="text-[10px] font-bold uppercase tracking-[0.15em] px-2 py-0.5 rounded-full bg-[#D4EDDB] text-[#1F2547]">
                {v.level}
              </span>
            )}
            {!v.active && (
              <span className="text-[10px] font-bold uppercase tracking-[0.15em] px-2 py-0.5 rounded-full bg-red-50 text-red-600">
                Hidden
              </span>
            )}
          </div>
          <a
            href={v.youtube_url}
            target="_blank"
            rel="noopener noreferrer"
            className="text-xs text-[#9F87D8] font-medium break-all"
          >
            {v.youtube_url}
          </a>
        </div>
      )}
    />
  );
}
